<app-companys-un-executive-filter
  (onEnter)="receiveFilterDate($event)"
  (geFilter)="receiveFilterCompany($event)"
  (siiFilter)="receiveChangeSiiFilter($event)"
  (pymeFilter)="receiveChangePymeFilter($event)"
></app-companys-un-executive-filter>

<main>
  <section class="container_first">
    <app-companys-un-executive-table
      class="container-grill-accum"
      [recieveFilterName]="clientes"
      [booleanFlag]="booleanFlag"
      [booleanText]="booleanText"
      [pagedProviderSummaries]="clientes"
      (changePagination)="receiveProviderPaginationChange($event)"
      (changeSorting)="receiveChangeSortingOrder($event)"
      class="width-grill"
    ></app-companys-un-executive-table>
  </section>
</main>
